module.exports = __webpack_public_path__ + "public/images/shedule-kam-mobile.2a7d16e1f761e35125feef1f2b0e2b59.png";